import type Controller from '@ember/controller';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class GenieChatIndexRoute extends Route {
	@service('ai-chat') declare aiChatService: Service.AIChat;

	override setupController(controller: Controller, model: unknown): void {
		super.setupController(controller, model);

		// /genie has no thread → clear the controlled thread id (drives the React mount to home).
		this.aiChatService.applyUrlThread(null);
	}
}
